<div class="asset-listview-view widget-bg-color">
  <sp-loading-inprogress *ngIf="loading; else loadingComplete" [diameter]="50" [showSpinner]="true"></sp-loading-inprogress>
  <ng-template #loadingComplete>
    <ng-template [ngIf]="assetData && assetData.length > 0">
      <sp-custom-generic-table
        #customGenericTable
        [tableCols]="columns"
        [tableData]="assetData"
        [tableName]="'asset-name-'"
        [offset]="offset"
        tableType="assets"
        [actionColumn]="true"
        [expandActionColumn]="groupedViewFlag"
        [configObject]="configObject"
        (clickSortFilter)="onClickSortFilter($event)"
        (clickAssetDetails)="openModal($event.tableData, $event.tableData._id, $event.i)"
        [itemSize]="itemSize"
        (checkboxChanged)="onSelectAsset($event)"
        (clickLoadMore)="clickLoadMore($event)"
      >
        <ng-template let-assetID let-i #rowActionMenu>
          <button mat-icon-button (click)="taskMenuTrigger.openMenu()" [attr.data-index]="i">
            <mat-icon class="material-icons-outlined">more_vert</mat-icon>
            <div
              class="overlayMenu"
              matTooltip="Asset actions"
              #taskMenuTrigger="matMenuTrigger"
              [matMenuTriggerFor]="assetActionMenu"
              (menuOpened)="menuOpened(assetID)"
              (menuClosed)="menuClosed(assetID)"
            ></div>
            <span *ngIf="isGuidedTourEnabled" tourAnchor="asset-list-item-quick-action.anchor.toggle" class="guided-tour-target absolute overlay-target"></span>
          </button>
          <mat-menu #assetActionMenu="matMenu" [overlapTrigger]="true">
            <ng-template matMenuContent>
              <thehubz-asset-action-menu
                [asset]="getAsset(assetID)"
                [assetIndex]="i"
                [configObject]="configObject"
                [collectionOwner]="collectionOwner"
                [collectionFlag]="collectionFlag"
                (editDraftAsset)="editDraftAsset($event)"
                (deleteAsset)="onDeleteAsset(assetID, $event.planDeletionFlag)"
                (clickBasket)="onClickBasket(assetID)"
                (downloadAsset)="onDownloadAsset(assetID)"
                (editAsset)="editAssets.emit($event)"
                (exportAsset)="onExportAsset(assetID)"
              >
              </thehubz-asset-action-menu>
            </ng-template>
          </mat-menu>
        </ng-template>
      </sp-custom-generic-table>
    </ng-template>
  </ng-template>
  <div class="progress-bar-container" *ngIf="!assetUploadStepperFlag && brandingKey === CustomClients.Vorwerk">
    <thehubz-asset-progress-bar [lastVisibleAssetIndex]="lastVisibleAssetIndex" [assetCount]="assetCount"></thehubz-asset-progress-bar>
  </div>
</div>
